import { getUrlParam } from '../../utils/getUrlParam';
import { assertDevModeAdsUrlParams } from './assertDevModeAdsUrlParams';
import { trackEvent } from '../../tracking/utils/initTracking';

// TODO: Ad stack change - figure out what to do with this
const onAdRendered = (event: googletag.events.SlotRenderEndedEvent) => {
  const slotElement = document.getElementById(event.slot.getSlotElementId());
  const atfSlot = slotElement?.closest('atf-ad-slot');
  const slotId = atfSlot?.id || '';

  trackEvent('ad_loaded', 'Ads', slotId);
};

export const initAds = (site: string) => {
  if (process.env.NODE_ENV === 'development') {
    /**
     * Notes:
     * - &stf_debug=true toggles debug mode
     * - &adkeyword=demoads toggles demo ads
     * - &ast_test=true toggles testing mode and avoids being blocked by the ad server
     */
    assertDevModeAdsUrlParams();
  }

  const adsConfigMap: {[site: string]: any;} = {
    'https://selbsttest.netdoktor.de': 'https://a.bf-ad.net/adengine/netdoktorde/adengine.js',
    'https://selbsttest.netdoktor.at': 'https://a.bf-ad.net/adengine/netdoktorat/adengine.js',
    'https://selbsttest.netdoktor.ch': 'https://a.bf-ad.net/adengine/netdoktorch/adengine.js',
    /** 'https://selbsttest.gesundheitsportal-privat.de': null, **/
    'https://stage.selbsttest.netdoktor.de': 'https://a.bf-ad.net/adengine/netdoktorde/adengine.js',
    'https://stage.selbsttest.netdoktor.at': 'https://a.bf-ad.net/adengine/netdoktorat/adengine.js',
    'https://stage.selbsttest.netdoktor.ch': 'https://a.bf-ad.net/adengine/netdoktorch/adengine.js',
    /** 'https://stage.selbsttest.gesundheitsportal-privat.de': null, **/
  };

  if (!adsConfigMap[site]) {
    throw new Error(`There is no ads configuration for ${site}`);
  }

  // Configure ads
  const adsConfig = {
    csid: getUrlParam('csid') ?? '',
    script: adsConfigMap[site],
  };

  // Make the configuration object global to be used in both `setGlobalOptions` and `bcnHelper`
  window.ndConfig = {
    ads: {
      device: 'smartphone',
      layout: 'questions',
      category: 'tests',
      customKeywords: {
        csid: adsConfig.csid,
      },
    }
  }

  // Initialize the `bcnHelper` with the same configs we pass for the `setGlobalOptions`
  window.bcnHelper = Object.assign({}, window.ndConfig.ads);

  window._aeq = window._aeq || [];
  window._aeq.push(['setGlobalOptions', window.ndConfig.ads]);

  // Configure and inject the Smart Audience script, should be added before ads
  const smartAudienceScript = document.createElement('script');
  smartAudienceScript.async = true;
  smartAudienceScript.setAttribute('data-config', "{'layout': 'questions'}");
  smartAudienceScript.src = 'https://a.bf-tools.net/de/de.js';
  document.head.appendChild(smartAudienceScript);

  // Inject ad script
  const script = document.createElement('script');
  script.async = true;
  script.src = adsConfig.script;
  document.head.appendChild(script);
};

// Used to register a page change for Smart Audience Framework
export const updateBCNHelper = (config: {} = {}) => {
  // This acts as a check that the ads are allowed and initialized
  if (window?.ndConfig?.ads) {
    window.bcnHelper = Object.assign({}, window.ndConfig.ads, config);
  }
};
